"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Compose multiple react refs.
 *
 * @returns A new ref that passes down the Element to all ref arguments.
 */

function composeRefs() {
  var refs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    refs[_i] = arguments[_i];
  }

  return function (value) {
    return refs.forEach(function (ref) {
      return setRef(ref, value);
    });
  };
}

exports.composeRefs = composeRefs;
/**
 * Changes the value of a ref.
 * The ref can be a function ref or a object ref.
 *
 * @param ref The ref to have its value changed.
 * @param value The new value.
 */

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    var mutableRef = ref;
    mutableRef.current = value;
  }
}

exports.setRef = setRef;
/**
 * Compose multiple event handlers.
 *
 * @returns A new function that triggers all handlers passed as parameters, in order.
 */

function composeHandlers() {
  var handlers = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    handlers[_i] = arguments[_i];
  }

  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return handlers.forEach(function (handler) {
      return handler.apply(void 0, args);
    });
  };
}

exports.composeHandlers = composeHandlers;